import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CourseService } from '../services/course.service';
import { switchMap, map, catchError, of } from 'rxjs';
import { courseActions } from './course.actions';

@Injectable()
export class CourseEffects {

  constructor(private actions$: Actions,
    private courseService: CourseService) {}

  // Define your effects here using the actions$ stream and courseService
  // For example, you can listen for actions and call service methods
  // to fetch courses, handle success and failure, etc.
  // Example effect:

  getCourses$ = createEffect(() => this.actions$.pipe(
      ofType(courseActions.getCourses),
      switchMap(() => this.courseService.getCourses().pipe(
          map(courses => courseActions.getCoursesSuccess( courses )),
          catchError(error => of(courseActions.getCoursesFailure({ error: error.message })))
      )
    ))
  );

  getCourse$ = createEffect(() => this.actions$.pipe(
      ofType(courseActions.getCourse),
      switchMap(action => this.courseService.getCourse(action.courseId).pipe(
          map(course => courseActions.getCourseSuccess(course)),
          catchError(error => of(courseActions.getCourseFailure({ error: error.message })))
      )
    ))
  );
}
